import React, { useState } from "react"

import { Form, Input, Label, Row, Col } from "reactstrap"

import KYCCompleteImage from "../../assets/images/gif/kyc-complete.gif"

const KYCComplete = () => {
  return (
    <>
      <div className="kyc-complete-wrapper">
        <img height={"250px"} src={KYCCompleteImage} alt="" />
        <h5 className="title my-3">Thank You</h5>
        <p>
          Your KYC process has been successfully completed and is currently
          under review. You will receive an update within 48 hours.
        </p>
        {/* <div className="d-flex align-items-center my-4">
          <button type="submit" className="btn btn-primary w-100">
            Thank You
          </button>
        </div> */}
      </div>
    </>
  )
}

export default KYCComplete
